// "Sound is blocked" (architecture sprint-14 §8.1): set when a Start-Shift or Test-sound play fails, cleared by a
// successful one. A tiny external store so the shell banner and the shift card share it without a provider.
import { useSyncExternalStore } from 'react';

let blocked = false;
const listeners = new Set<() => void>();

export function setSoundBlocked(value: boolean): void {
  if (blocked === value) return;
  blocked = value;
  for (const fn of listeners) fn();
}

export function useSoundBlocked(): boolean {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => blocked,
    () => false,
  );
}
